define('drops/actionSlideshow/actionSlide',[
    'jquery',
    'underscore',
    'lq'
], function ($, _, lq) {

    var ActionSlide = function (data) {
        this.url = this.getActionUrl(data);
        this.delay = data.delay;

        this.$element = $('<iframe frameBorder="0" />')
            .attr('src', this.url)
            .css({
                'visibility': 'hidden'
            });
    };

    ActionSlide.prototype.getActionUrl = function (data) {
        var targetUrl = lq.getTenantUrl('LicquidAction/Get/' + data.actionId);
        targetUrl += '?embedded=true&parameters=' + encodeURIComponent(JSON.stringify(data.parameters));
        return targetUrl;
    };

    ActionSlide.prototype.init = function ($parent) {
        var deferred = $.Deferred();

        var self = this;
        this.listenForMessage(function (e) {
            if (e.source !== self.$element.get(0).contentWindow)
                return;

            if (typeof e.data !== 'string')
                return;

            var obj = JSON.parse(e.data);

            if (obj.eventName === 'LicquidLoaded')
                deferred.resolve();
        });

        $parent.append(this.$element);

        return deferred.promise();
    };

    ActionSlide.prototype.listenForMessage = function (callback) {
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var messageEvent = window.addEventListener ? 'message' : 'onmessage';
        
        window[eventMethod](messageEvent, function (e) {
            callback(e);
        }, false);
    };

    ActionSlide.prototype.show = function () {
        this.$element.css({
            'visibility': 'inherit'
        });
    };

    ActionSlide.prototype.remove = function () {
        this.$element.remove();
    };

    ActionSlide.prototype.timeout = function() {
        var deferred = $.Deferred();
        _.delay(function () { deferred.resolve(); }, this.delay * 1000);
        return deferred.promise();
    };

    ActionSlide.prototype.hide = function () {
        this.$element.fadeOut();
    };

    return ActionSlide;
});
